module.exports = __webpack_public_path__ + "static/GminaMiastaChoczewo-fcd727754f85d8214371d91e4b444875.svg";